<i18n lang="yaml" locale="en">
  file type not allowed: This file type is not allowed.
</i18n>

<i18n lang="yaml" locale="de">
  file type not allowed: Dieser Dateityp wird nicht unterstützt.
</i18n>

<template>
  <span @click="handleClick">
    <input
      ref="input"
      type="file"
      :accept="accepted.join(',')"
      @change="handleFileChange"
      :multiple="multiple"
    >
    <slot />
  </span>
</template>

<script>
import { Error } from '@/plugins/snotify'

export default {
  props: {
    accepted: {
      type: Array,
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: false
    },
    readAs: {
      type: String,
      default: undefined,
      validator: (val) => {
        return !val || ['buffer', 'binary', 'url', 'text'].includes(val)
      }
    }
  },
  data () {
    return {
      filesRead: []
    }
  },
  computed: {
    readFn () {
      return {
        buffer: 'readAsArrayBuffer',
        binary: 'readAsBinaryString',
        url: 'readAsDataUrl',
        text: 'readAsText'
      }[this.readAs]
    }
  },
  methods: {
    handleFileInput (file) {
      const reader = new FileReader()
      reader.onload = this.onReaderLoad
      reader.readAsText(file)
    },
    handleFileChange () {
      const files = this.$refs.input.files
      let accepted = true
      for (const f of files) {
        if (!this.accepted.includes(f.type)) {
          new Error(this.$t('file type not allowed')).open()
          accepted = false
        }
      }
      if (accepted) {
        if (this.readAs) {
          this.readFiles(files)
        }
        this.emitChange(files)
      }
      this.$refs.input.value = null
    },
    readFiles (files) {
      const fileCount = files.length
      for (const f of files) {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.filesRead.push(f.type === 'application/json' ? JSON.parse(event.target.result) : event.target.result)
          if (this.filesRead.length === fileCount) {
            this.emitRead(this.filesRead)
            this.filesRead = []
          }
        }
        reader[this.readFn](f)
      }
    },
    emitRead (files) {
      this.$emit('read', this.multiple ? files : files[0])
    },
    emitChange (files) {
      this.$emit('change', this.multiple ? files : files[0])
    },
    handleClick () {
      this.$refs.input.click()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';
  input {
    display: none;
  }
</style>
